import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RedbaxAuthProvider, BffClientProvider, OrgProvider, ProtectedRoute } from '@redbax/shared';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <RedbaxAuthProvider>
      <ProtectedRoute>
        <QueryClientProvider client={queryClient}>
          <OrgProvider>
            <BffClientProvider>
              <RouterProvider router={router} />
            </BffClientProvider>
          </OrgProvider>
        </QueryClientProvider>
      </ProtectedRoute>
    </RedbaxAuthProvider>
  );
}
